import React, { FunctionComponent, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useLoadIfEmpty } from "../../hooks/useLoadIfEmpty";
import { thunkFetchTenantDistributors } from "../../store/tenants/actions";
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { AppState } from "../../store";
import { Distributor } from "../../models/Product";
import * as TenantApi from "../../api/tenantApi";
import { isOk } from "../../result";

interface DistributorSelectProps extends Omit<SelectProps, "loading"> {
  tenantId?: string;
  label?: string;
  onSelected?: (value?: Distributor) => void;
  onSelectedStrict?: (value: Distributor) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
}

export const DistributorSelect: FunctionComponent<DistributorSelectProps> = ({
  tenantId,
  label = "Distributor",
  onSelected,
  onSelectedStrict,
  onChange,
  variant = "standard",
  value,
  error = false,
  ...props
}) => {
  const tenantDistributors =
    useSelector<AppState, ReadonlyArray<Distributor>>(
      s => s.tenants.distributors
    ) || [];

  const [state, setState] = useState<ReadonlyArray<Distributor>>([]);

  useLoadIfEmpty(
    !tenantId && !tenantDistributors.length,
    thunkFetchTenantDistributors
  );

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    let section = state.find(x => x.id === event.target.value);
    if (onSelected) {
      onSelected(section);
    }
    if (onSelectedStrict) {
      if (section) {
        onSelectedStrict(section);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    if (tenantId) {
      TenantApi.listDistributorsForTenantId(tenantId).then(result => {
        if (isOk(result)) {
          setState(result.value);
        }
      });
    } else {
      let filtered =
        tenantDistributors &&
        tenantDistributors.length > 0 &&
        tenantDistributors &&
        tenantDistributors;

      if (filtered) {
        setState(filtered);
      }
    }
  }, [tenantDistributors]);

  return (
    <FormControl variant={variant} className={props.className} error={error}>
      <InputLabel
        id="distributor-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="distributor-select-label"
        id="distributor-select"
        autoWidth={true}
      >
        {onSelected ? <MenuItem key={undefined} value={undefined} /> : null}
        {state &&
          state.length > 0 &&
          state.map(x => (
            <MenuItem key={x.id} value={x.id}>
              <ListItemText primary={x.name} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
